import type { SegmentSummary } from '@/domains/pages/ai-proficiency/utils/map-segment-aggregates';
import type { SegmentKind } from '@/domains/pages/ai-proficiency/utils/segment-api-payloads';
import {
  applySegmentDisplayNames,
  getSegmentDisplayName,
} from '@/domains/pages/ai-proficiency/utils/segment-display';
import type { SavingsSegmentSummary } from '@/domains/pages/model-savings/types';

function toSegmentSummaries(segments: SavingsSegmentSummary[]): SegmentSummary[] {
  return segments.map((segment) => ({
    name: segment.name,
    score: null,
    scorePrev: null,
    delta: null,
    userCount: 0,
  }));
}

export function applySavingsSegmentDisplayNames(
  segments: SavingsSegmentSummary[],
  hasMapping: boolean,
  segmentKind: SegmentKind | null,
): SavingsSegmentSummary[] {
  if (!segmentKind) return segments;

  const labeled = applySegmentDisplayNames(toSegmentSummaries(segments), hasMapping, segmentKind);
  return segments.map((segment, index) => ({
    ...segment,
    displayName: labeled[index]?.displayName,
  }));
}

export function getSavingsSegmentDisplayName(
  name: string,
  segments: SavingsSegmentSummary[],
  hasMapping: boolean,
  segmentKind: SegmentKind | null,
): string {
  const segment = segments.find((item) => item.name === name);
  if (segment?.displayName) return segment.displayName;
  return getSegmentDisplayName(name, toSegmentSummaries(segments), hasMapping, segmentKind);
}
